import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getImage } from "../../../utils/cloudinarySizing";

const RequestsList = ({
  requests,
  handleDeleteRequest,
  editRequest,
  toggleJobStatusHandler,
  activeTab
}) => {

  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState({});
  const [brokenImages, setBrokenImages] = useState({});
  const [activeMenuId, setActiveMenuId] = useState(null);

  const toggleMenu = (id) => {
    setActiveMenuId(activeMenuId === id ? null : id);
  };

  const getActiveResponsesCount = (leads = []) =>
    leads.filter(
      (lead) => lead.status === "pending" || lead.status === "accepted"
    ).length;

  const getStatusToggleLabel = (req) => {
    // If tab is filtering active jobs → allow marking completed
    if (activeTab === "active") return "Mark Completed";

    // If tab is filtering completed jobs → allow marking active
    if (activeTab === "completed") return "Mark Active";

    // Tab = total → use job status itself
    return req.status === "completed" ? "Mark Active" : "Mark Completed";
  };

  const getRequestImage = (req) => req.images?.[0]?.image;

  useEffect(() => {
    requests.forEach((req) => {
      const src = getImage(req.images?.[0]?.image, "srv_sm");
      if (!src) return;

      const img = new Image();

      img.onload = () => {
        setImageLoaded((prev) => ({
          ...prev,
          [req.id]: true,
        }));
      };

      img.onerror = () => {
        setImageLoaded((prev) => ({
          ...prev,
          [req.id]: false,
        }));

        setBrokenImages((prev) => ({
          ...prev,
          [req.id]: true,
        }));
      };

      img.src = src;
    });
  }, [requests]);

  return (
    <div className="requests-list">
      {requests.map((req) => (
        <div
          key={req.id}
          className="request-item"
          onClick={() => navigate(`/home/my-requests/${req.id}`)}
        >
          <div className="request-top-row">

            <div className="thumbnail-wrapper">
              {(() => {
                const src = getImage(req.images?.[0]?.image, "srv_sm");
                const isLoaded = imageLoaded[req.id];
                const isBroken = brokenImages[req.id];

                if (!src || isBroken || !isLoaded) {
                  return (
                    <div className="job-thumbnail placeholder-thumbnail">
                      <span>No Image</span>
                    </div>
                  );
                }

                return (
                  <img
                    src={src}
                    alt="Job thumbnail"
                    className="job-thumbnail"
                    onError={() => {
                      setBrokenImages((prev) => ({
                        ...prev,
                        [req.id]: true,
                      }));
                    }}
                  />
                );
              })()}
            </div>

            <div className="request-content">
              <h2 className="request-title">
                {req.title}

                <span className={`request-status-badge ${req.status}`}>
                  {req.status === "completed" ? "Completed" : "Active"}
                </span>
              </h2>

              <div className="request-meta">
                <span>
                  <i className="fas fa-eye"></i> {req.views || 0}
                </span>
                <span>
                  <i className="fa-regular fa-address-card"></i>{" "}
                  {req.leads?.length }{" "}
                  {req.leads?.length  === 1 ? "response" : "responses"}
                </span>
              </div>
            </div>

            <button
              className="requests-ellipsis-button"
              onClick={(e) => {
                e.stopPropagation();
                toggleMenu(req.id);
              }}
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>

            {activeMenuId === req.id && (
              <div className="request-dropdown-menu">

                <button
                  className="request-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleJobStatusHandler(req.id);
                  }}
                >
                  <i className="fa-solid fa-check"></i>
                  {getStatusToggleLabel(req)}
                </button>

                <button
                  className="request-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    editRequest(req);
                  }}
                >
                  <i className="fas fa-pencil-alt"></i> Edit
                </button>

                <button
                  className="request-dropdown-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteRequest(req.id);
                  }}
                >
                  <i className="fas fa-trash job-delete"></i> Delete
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RequestsList;